import { IRouteData, MapRouteInfo as DefaultMapRouteInfo } from '@cian/frontend-newbuilding-map-component';
import classNames from 'classnames';
import * as React from 'react';

import { TRANSPORT_ACCESSIBILITY_SIDEBAR_WIDTH } from 'shared/constants/transportAccessibilityInfrastructure';

import * as styles from './MapRouteInfo.css';

export interface IMapRouteInfoProps {
  isFullscreen: boolean;
  route: IRouteData;
}

const MapRouteInfoComponent: React.FC<IMapRouteInfoProps> = ({ isFullscreen, route }) => {
  const left = isFullscreen ? '50%' : `${TRANSPORT_ACCESSIBILITY_SIDEBAR_WIDTH + 12}px`;

  return (
    <div className={classNames(styles['wrapper'], isFullscreen && styles['fullscreen'])} style={{ left }}>
      <DefaultMapRouteInfo route={route} />
    </div>
  );
};

export const MapRouteInfo = React.memo(MapRouteInfoComponent);
